import React from "react";
import Modal from "react-modal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Check, Copy, X } from "lucide-react";
import LinkIcon from "../ui/LinkIcon";
import Qr from "../Qr";

const shareModalStyles = {
  overlay: {
    backgroundColor: "rgba(15, 23, 42, 0.55)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    zIndex: 999,
  },
  content: {
    position: "relative",
    inset: "auto",
    border: "none",
    background: "transparent",
    padding: 0,
    borderRadius: 0,
    boxShadow: "none",
    maxWidth: "384px",
    width: "100%",
    margin: 0,
    overflow: "visible",
  },
};

const SOCIAL_SITES = [
  { href: "https://www.facebook.com/", icon: "fa-facebook", color: "text-blue-600" },
  { href: "https://www.instagram.com/", icon: "fa-instagram", color: "text-pink-600" },
  { href: "https://www.tiktok.com/en/", icon: "fa-tiktok", color: "text-slate-900" },
  { href: "https://www.youtube.com/", icon: "fa-youtube", color: "text-red-600" },
  { href: "https://www.linkedin.com/", icon: "fa-linkedin", color: "text-blue-400" },
  { href: "https://www.snapchat.com/", icon: "fa-snapchat", color: "text-yellow-500" },
];

const ShareModal = ({ isOpen, onClose, username, copied, onCopy, t }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    style={shareModalStyles}
    contentLabel={t("Share profile")}
  >
    <div className="relative bg-white rounded-3xl shadow-2xl w-full max-w-sm mx-auto p-6 sm:p-7">
      <button
        onClick={onClose}
        aria-label={t("Close")}
        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 flex items-center justify-center transition"
      >
        <X className="w-4 h-4" />
      </button>

      <h2 className="text-lg font-bold text-slate-900 text-center">
        {t("Share")}
      </h2>
      <p className="text-xs text-slate-400 text-center mt-1">
        {t("Share your profile link or QR code")}
      </p>

      <div className="mt-5 flex justify-center">
        <div className="rounded-2xl border border-slate-100 bg-slate-50 p-3">
          {username ? (
            <Qr url2={"https://linkakam.com/" + username.toString()} />
          ) : (
            ""
          )}
        </div>
      </div>

      <CopyToClipboard text={"linkakam.com/" + username}>
        <button
          onClick={onCopy}
          className="mt-5 w-full flex items-center justify-between gap-2 bg-slate-50 hover:bg-slate-100 border border-slate-200 rounded-xl px-4 py-3 text-left transition"
        >
          <span className="text-sm text-slate-600 truncate">
            linkakam.com/{username}
          </span>
          <span className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-600">
            {!copied ? <Copy className="w-4 h-4" /> : <Check className="w-4 h-4" />}
            {!copied ? t("copy") : t("copied")}
          </span>
        </button>
      </CopyToClipboard>

      <div className="mt-5 grid grid-cols-6 gap-3">
        {SOCIAL_SITES.map((site) => (
          <a
            key={site.icon}
            rel="noreferrer"
            target="_blank"
            href={site.href}
            className="aspect-square rounded-xl bg-slate-50 hover:bg-slate-100 flex items-center justify-center transition"
          >
            <LinkIcon value={site.icon} className={"text-xl sm:text-2xl " + site.color} />
          </a>
        ))}
      </div>
    </div>
  </Modal>
);

export default ShareModal;
